import { TopExtendQuestionCollapse } from 'components/top/extend/questions/collapse'
import { CopySvg } from 'components/top/extend/svg/copy'
import { LeftSlashSvg } from 'components/top/extend/svg/left-slash'
import { RightSlashSvg } from 'components/top/extend/svg/right-slash'
import { ELEMENT_ID } from 'utils/constant'
import { getGTM } from 'utils/functions'

export function PCPointPart06() {
  return (
    <div
      id={ELEMENT_ID.FAQ}
      className={`d-pb-[80px] d-pt-[95px] d-px-[40px] background-morning bg-repeat`}
    >
      <div className='max-w-[1000px] mx-auto w-full flex flex-col relative'>
        <div className='flex items-center justify-center d-gap-[8px]'>
          <LeftSlashSvg className='d-w-[15px] d-h-[15px]' />
          <h2 className='font-semibold d-text-[32px] d-leading-[64px] d-tracking-[3.2px]'>
            ポイントのよくある質問
          </h2>
          <RightSlashSvg className='d-w-[15px] d-h-[15px]' />
        </div>

        <div className='flex items-center d-gap-[12px] d-mt-[16px]'>
          <span className='rounded-full bg-accent-green d-w-[18px] d-h-[18px]' />
          <h3 className='font-semibold d-text-[24px] d-leading-[30px] d-tracking-[2.4px]'>
            サントリーウエルネスポイント
          </h3>
        </div>

        <div className='d-mt-[16px]'>
          <TopExtendQuestionCollapse
            title='ジハンピ対象の自販機でポイントを利用するにはどうすればいいですか？'
            {...getGTM({
              event_name: 'accordion_click',
              content_type: 'point_FAQ',
              content_id: 'ウエルネスポイント_1',
            })}
            duration={0.5}
          >
            <div className='rounded-b-lg bg-bg-blue flex items-start d-gap-[16px] d-p-[24px]'>
              <img
                src='/images/top-extend/questions/a.webp'
                alt='answer'
                className='object-contain d-w-[42px]'
              />
              <div className='grid grid-cols-2 d-gap-[24px] w-full'>
                <div className='bg-white rounded-[4px] flex items-center d-p-[24px] col-span-2'>
                  <div>
                    <p className='d-text-[16px] leading-[1.8] tracking-widest font-semibold'>
                      ご利用の前に、まずはComadoアプリマイページで
                      <br />
                      「利用可能ポイント」をご確認ください。
                    </p>
                    <p className='d-mt-[12px] d-text-[14px]'>
                      ※利用可能ポイントが購入金額よりも少ない場合はご利用できません。
                    </p>
                  </div>
                  <img
                    src='/images/top-extend/questions/1/pic-01.webp'
                    alt='ご利用の前に、まずはComadoアプリマイページで「利用可能ポイント」をご確認ください。'
                    className='object-contain d-w-[374px] ml-auto'
                  />
                </div>

                <div className='d-p-[24px] rounded-[4px] bg-white'>
                  <div className='flex before:content-["1"] before:shrink-0 before:d-mr-[12px] before:d-w-[24px] before:d-h-[24px] before:rounded-full before:d-border-[2px] before:border-illust-tealblue before:flex before:items-center before:justify-center before:d-text-[14px] before:leading-none before:font-semibold'>
                    <span className='font-semibold d-text-[14px] leading-[1.8] tracking-widest'>
                      Comadoアプリのマイページから「自販機で利用する（ジハンピ）」画面を表示する
                    </span>
                  </div>
                  <div className='w-full d-pl-[36px] d-mt-[16px]'>
                    <img
                      src='/images/top-extend/questions/1/pic-02.webp'
                      alt='Comadoアプリのマイページから「自販機で利用する（ジハンピ）」画面を表示する'
                      className='object-contain w-full aspect-[351/290]'
                    />
                  </div>
                </div>

                <div className='d-p-[24px] rounded-[4px] bg-white'>
                  <div className='flex before:content-["2"] before:shrink-0 before:d-mr-[12px] before:d-w-[24px] before:d-h-[24px] before:rounded-full before:d-border-[2px] before:border-illust-tealblue before:flex before:items-center before:justify-center before:d-text-[14px] before:leading-none before:font-semibold'>
                    <span className='font-semibold d-text-[14px] leading-[1.8] tracking-widest'>
                      自販機の商品ボタンを押す
                    </span>
                  </div>
                  <div className='w-full d-pl-[36px] d-mt-[44px]'>
                    <img
                      src='/images/top-extend/questions/1/pic-03.webp'
                      alt='自販機の商品ボタンを押す'
                      className='object-contain w-full aspect-[351/186]'
                    />
                  </div>
                </div>

                <div className='d-p-[24px] rounded-[4px] bg-white'>
                  <div className='flex before:content-["3"] before:shrink-0 before:d-mr-[12px] before:d-w-[24px] before:d-h-[24px] before:rounded-full before:d-border-[2px] before:border-illust-tealblue before:flex before:items-center before:justify-center before:d-text-[14px] before:leading-none before:font-semibold'>
                    <span className='font-semibold d-text-[14px] leading-[1.8] tracking-widest'>
                      Comadoアプリで「タッチを開始する」を押す
                    </span>
                  </div>
                  <div className='w-full d-pl-[36px] d-mt-[44px]'>
                    <img
                      src='/images/top-extend/questions/1/pic-04.webp'
                      alt='Comadoアプリで「タッチを開始する」を押す'
                      className='object-contain w-full aspect-[351/290]'
                    />
                  </div>
                </div>

                <div className='d-p-[24px] rounded-[4px] bg-white'>
                  <div className='flex before:content-["4"] before:shrink-0 before:d-mr-[12px] before:d-w-[24px] before:d-h-[24px] before:rounded-full before:d-border-[2px] before:border-illust-tealblue before:flex before:items-center before:justify-center before:d-text-[14px] before:leading-none before:font-semibold'>
                    <span className='font-semibold d-text-[14px] leading-[1.8] tracking-widest'>
                      以下が表示されたら、ジハンピ対応端末にスマートフォンの背面（カメラ側）でタッチする
                    </span>
                  </div>
                  <div className='w-full d-pl-[36px] d-mt-[16px]'>
                    <img
                      src='/images/top-extend/questions/1/pic-05.webp'
                      alt='以下が表示されたら、ジハンピ対応端末にスマートフォンの背面（カメラ側）でタッチする'
                      className='object-contain w-full aspect-[351/339]'
                    />
                  </div>
                </div>
              </div>
            </div>
          </TopExtendQuestionCollapse>
        </div>

        <div className='d-mt-[16px]'>
          <TopExtendQuestionCollapse
            title='サントリーウエルネスポイントは何をすれば貯まりますか？'
            {...getGTM({
              event_name: 'accordion_click',
              content_type: 'point_FAQ',
              content_id: 'ウエルネスポイント_2',
            })}
          >
            <div className='rounded-b-lg bg-bg-blue flex items-start d-gap-[16px] d-p-[24px]'>
              <img
                src='/images/top-extend/questions/a.webp'
                alt='answer'
                className='object-contain d-w-[42px]'
              />
              <p className='font-medium d-text-[18px] d-leading-[32px] d-tracking-[1.8px]'>
                ・サントリーウエルネス商品（定期的なお届けも含む）や
                <br />
                サントリーグループ商品のご購入によってポイントが貯まります。
                <br />
                ・オトク継続便のお客様で、Comadoアプリをご利用いただき、
                <br />
                飲用習慣タスクや健康習慣タスクを実行いただくことでポイントがたまります。
              </p>
            </div>
          </TopExtendQuestionCollapse>
        </div>

        <div className='d-mt-[16px]'>
          <TopExtendQuestionCollapse
            title='貯まったポイントは何ポイントから使えますか?'
            duration={0.2}
            {...getGTM({
              event_name: 'accordion_click',
              content_type: 'point_FAQ',
              content_id: 'ウエルネスポイント_3',
            })}
          >
            <div className='rounded-b-lg bg-bg-blue flex items-center d-gap-[16px] d-p-[24px]'>
              <img
                src='/images/top-extend/questions/a.webp'
                alt='answer'
                className='object-contain d-w-[42px]'
              />
              <p className='font-medium d-text-[18px] d-leading-[32px] d-tracking-[1.8px]'>
                1ポイントから利用することができます。
              </p>
            </div>
          </TopExtendQuestionCollapse>
        </div>

        <div className='flex items-center d-gap-[12px] d-mt-[40px]'>
          <span className='rounded-full bg-accent-green d-w-[18px] d-h-[18px]' />
          <h3 className='font-semibold d-text-[24px] d-leading-[30px] d-tracking-[2.4px]'>
            チャレンジ
          </h3>
        </div>

        <div className='d-mt-[16px]'>
          <TopExtendQuestionCollapse
            title='チャレンジに達成期限はありますか'
            {...getGTM({
              event_name: 'accordion_click',
              content_type: 'point_FAQ',
              content_id: 'チャレンジ_1',
            })}
          >
            <div className='rounded-b-lg bg-bg-blue flex items-start d-gap-[16px] d-p-[24px]'>
              <img
                src='/images/top-extend/questions/a.webp'
                alt='answer'
                className='object-contain d-w-[42px]'
              />
              <p className='font-medium d-text-[18px] d-leading-[32px] d-tracking-[1.8px]'>
                チャレンジには全部で4つのカテゴリがあり、カテゴリにより達成期限は異なります。
                <br />
                ・はじめてのチャレンジ：オトク継続便ご契約状態でログインいただいてから7日間です。
                <br />
                ・今日のチャレンジ：毎日0:00に達成記録がリセットされるため、達成期限は毎日23:59です。
                <br />
                ・週間のチャレンジ：毎週月曜日0:00に達成記録がリセットされるため、達成期限は毎週日曜日23:59です。
                <br />
                ・限定チャレンジ：各限定チャレンジに記載されている期日の23:59です。
              </p>
            </div>
          </TopExtendQuestionCollapse>
        </div>

        <div className='d-mt-[16px]'>
          <TopExtendQuestionCollapse
            title='4,000歩数以上歩いたのにポイントが貯まりません。'
            {...getGTM({
              event_name: 'accordion_click',
              content_type: 'point_FAQ',
              content_id: 'チャレンジ_2',
            })}
          >
            <div className='rounded-b-lg bg-bg-blue flex items-start d-gap-[16px] d-p-[24px]'>
              <img
                src='/images/top-extend/questions/a.webp'
                alt='answer'
                className='object-contain d-w-[42px]'
              />
              <div className='flex flex-col'>
                <p className='font-medium d-text-[18px] d-leading-[30px] d-tracking-[0.72px]'>
                  歩数でポイントを貯めるためには、4,000歩歩いた当日中にComadoアプリを開き、「トップページ」もしくは「歩数記録ページ」を訪れる必要があります。
                </p>

                <div className='flex items-center d-gap-[8px] d-mt-[16px]'>
                  <div className='d-w-[24px] d-h-[24px] rounded-full d-border-[2px] border-illust-tealblue flex items-center justify-center'>
                    <span className='d-text-[14px] d-leading-[16px] text-black font-semibold'>
                      1
                    </span>
                  </div>
                  <p className='d-text-[18px] d-leading-[36px] d-tracking-[1.8px] font-semibold'>
                    ComadoのTOPページに訪れる
                  </p>
                </div>
                <img
                  src='/images/point/part-06/pic-01.webp'
                  alt='ComadoのTOPページに訪れる'
                  className='d-w-[408px] d-mt-[8px] object-contain'
                />
                <div className='flex items-center d-gap-[8px] d-mt-[16px]'>
                  <div className='d-w-[24px] d-h-[24px] rounded-full d-border-[2px] border-illust-tealblue flex items-center justify-center'>
                    <span className='d-text-[14px] d-leading-[16px] text-black font-semibold'>
                      2
                    </span>
                  </div>
                  <p className='d-text-[18px] d-leading-[36px] d-tracking-[1.8px] font-semibold'>
                    歩数記録ページに訪れる
                  </p>
                </div>
                <img
                  src='/images/point/part-06/pic-02.webp'
                  alt='pic-02'
                  className='d-w-[408px] d-mt-[8px] object-contain'
                />

                <p className='d-text-[18px] d-leading-[30px] d-tracking-[0.72px] d-mt-[8px] font-medium'>
                  アプリを開いても歩数が「0歩」と表示されている場合、
                  <br />
                  恐れ入りますが以下のよくある質問をご確認ください。
                  <br />
                  ・iPhoneをご利用の方
                  <br />
                  よくある質問＞歩数＞常に0歩と表示されてしまう（iPhone）
                  <br />
                  ・Androidをご利用の方
                  <br />
                  よくある質問＞歩数＞常に0歩と表示されてしまう（Android）
                </p>
              </div>
            </div>
          </TopExtendQuestionCollapse>
        </div>

        <div className='d-mt-[16px]'>
          <TopExtendQuestionCollapse
            title='ポイントはどのタイミングでもらえますか？'
            {...getGTM({
              event_name: 'accordion_click',
              content_type: 'point_FAQ',
              content_id: 'チャレンジ_3',
            })}
          >
            <div className='rounded-b-lg bg-bg-blue flex items-start d-gap-[16px] d-p-[24px]'>
              <img
                src='/images/top-extend/questions/a.webp'
                alt='answer'
                className='object-contain d-w-[42px]'
              />
              <p className='font-medium d-text-[18px] d-leading-[32px] d-tracking-[1.8px]'>
                ポイントの種類によってタイミングが異なります。
                <br />
                以下のタイミングで、今回、獲得頂いたポイントが、これまでためていたポイントに加算されます。
                <br />
                <br />
                ■サントリーウエルネス商品購入によって獲得するポイント
                <br />
                ご注文頂いた商品を出荷した翌日にポイントが反映されます。
                <br />
                ECサイトの注文完了時点、または、お電話による注文完了時点ではありません。目安として、注文完了時点から数日後の反映となります。
                <br />
                <br />
                ■Comadoアプリの対象チャレンジ実行によって獲得するポイント
                <br />
                ポイント進呈対象となる「チャレンジ」を実行した翌週の月曜日に、ポイントが進呈されます。
                <br />
                <br />
                但し、キャンペーンなどによるポイント進呈のタイミングは上記の限りではありません。
              </p>
            </div>
          </TopExtendQuestionCollapse>
        </div>

        <a
          target='_blank'
          href='https://secure.okbiz.jp/swe/category/show/37?key=400000147'
          className='flex items-baseline d-gap-[4px] d-mt-[32px] mx-auto'
        >
          <span className='d-text-[18px] d-leading-[32px] d-tracking-[1.8px] font-medium underline'>
            よくある質問をもっと見る
          </span>
          <CopySvg className='d-w-[20px] d-h-[20px]' />
        </a>
      </div>
    </div>
  )
}
